(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/api/assets/javascripts/fetch-alias.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/api/assets/javascripts/fetch-alias.js');
"use strict";

let logger;
let jupiter;
if (svs.isServer) {
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  logger = trinidad.logger('module:bingo_react:components:api:fetchAlias');
  jupiter = trinidad.jupiter;
} else {
  logger = svs.core.log.getLogger('module:bingo_react:components:api:fetchAlias');
  jupiter = svs.core.jupiter;
}
const fetchAlias = async req => {
  try {
    const fetchOptions = {
      method: 'GET',
      path: '/player/1/alias'
    };
    if (svs.isServer) {
      fetchOptions.req = req;
    }
    const result = await jupiter.callAsync(fetchOptions);
    const playerAlias = svs.isServer ? result.alias : result.response.alias;
    return playerAlias;
  } catch (e) {
    logger.error("Error fetching player alias ".concat(e), req);
    throw e;
  }
};
if (svs.isServer) {
  module.exports = fetchAlias;
} else {
  setGlobal('svs.bingo_react.components.api.fetchAlias', fetchAlias);
}

 })(window);